import { formatDate } from '../util/date_new'
import { loadImage, loadImageNew } from '../util/image'

export default class {
  public id
  public moTa
  public noiDung
  // public hinhThumbnail
  public image
  public tieuDe
  public tenDanhMuc
  public timePublish : string
  public url
  public danhMuc
  public seo
  public danhMucTinId

  constructor(options) {
    let hinh = options.hinh || {}
    let image = hinh.hinh_goc || options.hinh_thumbnail
    let seo = options.json_seo ? options.json_seo : {}

    // options.hinh = options.hinh ? options.hinh : {}
    this.danhMucTinId = options.danh_muc_tin_id || null
    this.id = options.tin_tuc_id || null
    this.moTa = options.mo_ta || ''
    this.noiDung = options.noi_dung || ''
    this.image = image ? loadImageNew(image, 'NEWS') : ''
    this.tieuDe = options.tieu_de || ''
    this.tenDanhMuc = options.danh_muc_ten || ''
    this.timePublish = options.time_publish
      ? formatDate(new Date(options.time_publish))
      : ''
    this.url = options.url || ''
    // this.danhMuc = options.danh_muc || []
    this.seo = {
      title: seo.tieu_de || '',
      moTa: seo.mo_ta || '',
      status: seo.status || false,
      tag: seo.tag_seo || [],
      hinh: seo.hinh_seo || '',
    }
  }
}
